export default __webpack_public_path__ + "static/media/33.85ca5f6b.png";